export const EMPLOYEE_SETTINGS_QUERY_KEY = 'employeeSettings'
